<div class="container">
	<h2 class="title">{{ 'notFound.title' | translate }}</h2>
	<p class="description">{{ 'notFound.description' | translate }}</p>
</div>
